// extracted by mini-css-extract-plugin
module.exports = {"ProWbLink":"pro-wb-link_ProWbLink__udEd5"};